export const __removeAllIDs = (impl, ids) => {
    let ok = true;
    for (let id of ids) {
        ok = impl.removeID(id) && ok;
    }
    return ok;
};
